import React from "react";

const POPLATKY = [
  ["vstupny", "Vstupný"],
  ["manazersky", "Manažérsky"],
  ["vykonnostny", "Výkonnostný"],
];

function normalizujText(hodnota) {
  return typeof hodnota === "string"
    ? hodnota.trim()
    : "";
}

function formatujPercento(hodnota) {
  const cislo = Number(hodnota);

  return Number.isFinite(cislo)
    ? cislo.toLocaleString("sk-SK")
    : "0";
}

function formatujPoplatok(poplatok) {
  if (!poplatok) return "—";

  const od = Number(poplatok.od);
  const doHodnota = Number(poplatok.do);

  const platneOd = Number.isFinite(od)
    ? od
    : 0;

  const platneDo = Number.isFinite(
    doHodnota
  )
    ? doHodnota
    : platneOd;

  const rozsah =
    platneOd === platneDo
      ? `${formatujPercento(platneOd)} %`
      : `${formatujPercento(
          platneOd
        )}–${formatujPercento(
          platneDo
        )} %`;

  const dph = normalizujText(
    poplatok.dph
  );

  return dph
    ? `${rozsah} + DPH ${dph}`
    : rozsah;
}

function vytvorTextTypu(produkt) {
  const nazov = normalizujText(
    produkt?.typ?.nazov
  );

  const skratka = normalizujText(
    produkt?.typ?.skratka
  );

  if (nazov && skratka) {
    return `${nazov} (${skratka})`;
  }

  return nazov || skratka;
}

function ziskajOdkaz(
  produkt,
  kluc
) {
  return normalizujText(
    produkt?.info?.[kluc]?.odkaz
  );
}

export function maInvesticneProduktInfo(
  produkt
) {
  return Boolean(
    vytvorTextTypu(produkt) ||
    ziskajOdkaz(
      produkt,
      "podklady"
    ) ||
    ziskajOdkaz(
      produkt,
      "manual"
    )
  );
}

export function InvesticnePoplatkyPopoverObsah({
  produkt,
}) {
  const polozky = POPLATKY.map(
    ([kluc, nazov]) => {
      const poplatok =
        produkt?.poplatky?.[
          kluc
        ];

      return {
        kluc,
        nazov,
        poplatok,
        poznamka:
          normalizujText(
            poplatok?.poznamka
          ),
        dph:
          normalizujText(
            poplatok?.dph
          ),
      };
    }
  );

  const maNenulovyPoplatok =
    polozky.some(
      ({ poplatok }) => {
        if (!poplatok) {
          return false;
        }

        const od =
          Number(poplatok.od);

        const doHodnota =
          Number(poplatok.do);

        return (
          (Number.isFinite(od) &&
            od !== 0) ||
          (Number.isFinite(
            doHodnota
          ) &&
            doHodnota !== 0)
        );
      }
    );

  const maDph =
    polozky.some(
      ({ dph }) =>
        Boolean(dph)
    );

  const poznamky =
    polozky.filter(
      ({ poznamka }) =>
        Boolean(poznamka)
    );

  const zobrazLenPoznamky =
    !maNenulovyPoplatok &&
    !maDph &&
    poznamky.length > 0;

  if (zobrazLenPoznamky) {
    return (
      <span className="invest-odporucania-popover__content">
        {poznamky.map(
          ({
            kluc,
            poznamka,
          }) => (
            <span
              key={kluc}
              className="invest-odporucania-popover__group"
            >
              <span className="invest-odporucania-popover__note">
                {poznamka}
              </span>
            </span>
          )
        )}
      </span>
    );
  }

  return (
    <span className="invest-odporucania-popover__content">
      {polozky.map(
        ({
          kluc,
          nazov,
          poplatok,
          poznamka,
        }) => (
          <span
            key={kluc}
            className="invest-odporucania-popover__group"
          >
            <span className="invest-odporucania-popover__value">
              <strong>
                {nazov}:
              </strong>{" "}
              {formatujPoplatok(
                poplatok
              )}
            </span>

            {poznamka ? (
              <span className="invest-odporucania-popover__note">
                {poznamka}
              </span>
            ) : null}
          </span>
        )
      )}
    </span>
  );
}

export function InvesticneInfoPopoverObsah({
  produkt,
}) {
  const typProduktu =
    vytvorTextTypu(produkt);

  const podklady =
    ziskajOdkaz(
      produkt,
      "podklady"
    );

  const manual =
    ziskajOdkaz(
      produkt,
      "manual"
    );

  return (
    <span className="invest-odporucania-info-popover__content">
      {typProduktu ? (
        <strong className="invest-odporucania-info-popover__title">
          {typProduktu}
        </strong>
      ) : null}

      {podklady || manual ? (
        <span className="invest-odporucania-info-popover__links">
          {podklady ? (
            <span className="invest-odporucania-info-popover__row">
              <span>Podklady</span>

              <a
                href={podklady}
                target="_blank"
                rel="noopener noreferrer"
                className="invest-odporucania-info-popover__link"
              >
                Link
              </a>
            </span>
          ) : null}

          {manual ? (
            <span className="invest-odporucania-info-popover__row">
              <span>Manuál</span>

              <a
                href={manual}
                target="_blank"
                rel="noopener noreferrer"
                className="invest-odporucania-info-popover__link"
              >
                Link
              </a>
            </span>
          ) : null}
        </span>
      ) : null}
    </span>
  );
}